import { FC } from 'react';
import cn from 'classnames';

import './Loader.scss';

type LoaderProps = {
    relative?: boolean;
    active: boolean;
    message?: string;
};

const Loader: FC<LoaderProps> = ({ relative, active, message }) => {
    return (
        <div
            className={cn('loader', {
                loader_relative: relative,
                loader_active: active,
            })}
        >
            <div className="loader__error-message">
                {message}
            </div>
        </div>
    );
};

export default Loader;
